module.exports = __webpack_public_path__ + "static/media/LazyAz_web6.c643ebc6.jpg";